import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetModelTreeResData } from "./GetModelTreeResData";

const ENDPOINT = "/device/model_tree";

export class GetModelTreeCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetModelTreeResData> {
        let res = await this.executeCommand();
        return new GetModelTreeResData(res);
    }
}
